<template>
    <div>
        <HeaderView />
        <div class="body_area">
            <div class="body_area after_bg sm">
                <UserTop />

                <div class="container">
                    <div class="row clearfix">
                        <div class="col-lg-12 col-xl-12">
                            <div class="card chat_app">
                                <router-view />
                            </div>
                        </div>
                    </div>
                    <FooterView />
                </div>
            </div>
        </div>
        <UserMoveFolder />
        <UserRename />

        <!--    <UserAuth />-->
    </div>
</template>


<script>
import HeaderView from "@/components/common/HeaderView";
import UserTop from "@/components/user/common/UserTop";
import FooterView from "@/components/common/FooterView";
import UserMoveFolder from "@/components/user/modal/UserMoveFolder";
import UserRename from "@/components/user/modal/UserRename";

export default {
    name: 'WorkflowLayout',
    components: {
        HeaderView,
        UserTop,
        FooterView,
        UserMoveFolder,
        UserRename,
    },
    data() {
        return {
        }
    },
    methods: {
    },
    created() {
        console.log('WorkflowLayout created')
    },
    mounted() {
        console.log('WorkflowLayout created')
    },
    beforeDestroy() {
        console.log('WorkflowLayout beforeDestroy')
    }
}
</script>

